import Image from "next/image";
import Link from "next/link";
import { useParams, usePathname } from "next/navigation";
import React from "react";

export default function LanguageMobile({ onClose }: { onClose?: () => void }) {
  const params = useParams();
  const pathname = usePathname();
  const locale = (params?.locale as string) || "vi";

  // Build path with new locale by replacing the first segment
  const buildLocalePath = (newLocale: string) => {
    const segments = pathname.split("/");
    segments[1] = newLocale;
    return segments.join("/");
  };

  const handleSelect = (newLocale: string) => {
    document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`;
    if (onClose) onClose();
  };

  return (
    <div style={{ display: "flex", pointerEvents: "auto" }}>
      <Link scroll={false} href={buildLocalePath("vi")} onClick={() => handleSelect("vi")} style={{ pointerEvents: "auto" }}>
        <div
          style={{
            marginTop: "10px",
            marginLeft: "12px",
            cursor: "pointer",
            width: 27,
            height: 18,
            filter: locale !== "vi" ? "grayscale(100%)" : undefined,
          }}
        >
          <Image
            src="/icons/icon_VnFlag.svg"
            alt="Ngôn ngữ Việt"
            width={27}
            height={18}
            style={{ objectFit: "contain" }}
          />
        </div>
      </Link>
      <Link scroll={false} href={buildLocalePath("en")} onClick={() => handleSelect("en")} style={{ pointerEvents: "auto" }}>
        <div
          style={{
            marginTop: "10px",
            marginLeft: "12px",
            cursor: "pointer",
            width: 27,
            height: 18,
            filter: locale !== "en" ? "grayscale(100%)" : undefined,
          }}
        >
          <Image
            src="/icons/icon_EnFlag.svg"
            alt="English"
            width={27}
            height={18}
            style={{ objectFit: "cover" }}
          />
        </div>
      </Link>
    </div>
  );
}
